/* import __COLOCATED_TEMPLATE__ from './header-controls.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

export interface HeaderControlsArgs {
  hasSessions: boolean;
  verboseLogsEnabled: boolean;
  copyLatestSessionId: () => Promise<void>;
  copyTranscript: () => Promise<void>;
  toggleVerboseLogsEnabled: () => void;
  reportIssue?: () => void;
}

interface Signature {
  Args: HeaderControlsArgs;
  Element: HTMLElement;
}

export default class HeaderControls extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  @action handleToggleVerboseLogs() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'toggle_verbose_logs',
      verbose_logs_enabled: this.args.verboseLogsEnabled,
    });
    this.args.toggleVerboseLogsEnabled();
  }

  @action handleCopyLatestSessionId() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'copy_latest_session_id',
    });
    this.args.copyLatestSessionId();
  }

  @action handleCopyTranscript() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'copy_transcript',
    });
    this.args.copyTranscript();
  }

  @action handleReportIssue() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'report_issue',
    });
    this.args.reportIssue?.();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::HeaderControls': typeof HeaderControls;
  }
}
